module.exports = __webpack_public_path__ + "static/media/right-arrow.69767f66.svg";